const getAuditorIdentity = (row, index) => {
  const candidate = row?.employeeId
    ?? row?.userId
    ?? row?.employeeEmail
    ?? row?.employeeName;
  const normalized = String(candidate ?? '').trim().toLowerCase();
  return normalized || `unidentified-row-${index}`;
};

// Initial Certification returns one schedule row for Stage 1 and one for Stage 2.
// The same person can be booked on both, but the success message must count people,
// not stage rows.
export const countAutoBookedAuditors = (rows = []) => {
  const identities = new Set();
  (Array.isArray(rows) ? rows : []).forEach((row, index) => {
    if (row?.autoBooked !== true) return;
    identities.add(getAuditorIdentity(row, index));
  });
  return identities.size;
};

const stageLabel = (stageKey) => {
  if (stageKey === 'stage1') return 'Initial Certification Stage 1';
  if (stageKey === 'stage2') return 'Stage 2';
  return '';
};

export const buildAutoBookingSuccessMessage = (rows = []) => {
  const autoBookedRows = (Array.isArray(rows) ? rows : []).filter((row) => row?.autoBooked === true);
  const auditorCount = countAutoBookedAuditors(autoBookedRows);
  if (auditorCount === 0) return '';

  const auditorPhrase = `${auditorCount} auditor${auditorCount === 1 ? ' was' : 's were'}`;
  const stageLabels = Array.from(new Set(autoBookedRows
    .map((row) => stageLabel(row?.stageKey))
    .filter(Boolean)));

  if (stageLabels.includes('Initial Certification Stage 1') && stageLabels.includes('Stage 2')) {
    return `Scheduling saved. ${auditorPhrase} auto-booked across Initial Certification Stage 1 and Stage 2. Stage 2 was prepared automatically using the same qualified auditor.`;
  }

  return `Scheduling saved. ${auditorPhrase} auto-booked by the system based on competency and availability.`;
};
